<div class="container">
    <div class="title-container">
        <h2 class="mat-title">Gestion des Packs Thematiques</h2>
    </div>

    <div class="tv-ns-custom-horizontal-divider"></div>
    <!-- Options -->
    <div class="options-container">
            <!-- Year selector -->
            <div class="tv-container-select-white-rect-extensible width-230px">
                <mat-form-field>
                    <mat-icon matPrefix>calendar_today</mat-icon>
                    <mat-select
                        panelClass="tv-custom-always-visible-scroll-bar"
                        class="tv-ns-select-option"
                        [formControl]="selectedYearFormControl"
                    >
                        <mat-option *ngFor="let year of availableYears" class="tv-ns-select-option" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="search-container">
                <!-- Channels Filter -->
                <div class="tv-round-input-extensible-no-label width-300px">
                    <mat-form-field>
                        <mat-icon matPrefix>search</mat-icon>
                        <input
                            class="tv-ns-select-option"
                            matInput
                            type="text"
                            [formControl]="searchPackFormControl"
                        >
                    </mat-form-field>
                </div>
                <button 
                    (click)="openThemaPackManagingModal('create')"
                    class="tv-round-icon-button-icon-medium-light-blue"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
    </div>
    <!-- Packs -->
    <div class="pack-list-container tv-custom-always-visible-scroll-bar">
        <div *ngIf="isPacksLoading" class="loader-container">
            <mat-spinner diameter="60" class="light-spinner"></mat-spinner>
        </div>

        <ng-container *ngIf="!isPacksLoading  && (filteredContractPacks$ | async) as items">
            <div *ngFor="let item of items; let i = index">
                <div class="pack-container">
                    <!-- Primary Infos -->
                    <div class="pack-infos">
                        <span>{{ item.id }}</span>
                        <span class="pack-label">{{ item.label }}</span>
                        <span matTooltip="Taux Def" matTooltipClass="custom-tv-tooltip">{{ item.defTx }}%</span>
                    </div>
                    <!-- Channels -->
                    <ng-container *ngIf="item.contractPackChannels.length > 0">
                        <div 
                          class="pack-channels"
                        >
                            <div
                                *ngFor="let channelPack of item.contractPackChannels"
                                class="channel-infos"
                                matTooltip="{{ channelPack.channel.name }} ( {{ channelPack.channel.channelCode }} ) - {{ channelPack.rate }} %"
                                matTooltipClass="custom-tv-tooltip"
                            >
                                <img class="channel-logo" [src]="channelPack.channel.logo" alt="logo"/>
                                <span>{{ channelPack.rate }} %</span>
                                <span class="channel-separator">/</span>
                          </div>
                        </div>
                    </ng-container>
                    <!-- Action buttons -->
                    <div class="pack-actions">
                        <mat-icon svgIcon="edit" (click)="openThemaPackManagingModal('edit', item)"></mat-icon>
                        <mat-icon
                            svgIcon="content-copy"
                            (click)="duplicatePack(item)"
                            matTooltip="Dupliquer pour l'année du contrat actuel"
                            matTooltipClass="custom-tv-tooltip"
                        ></mat-icon>
                        <mat-icon class="material-icons-outlined delete-action-icon" (click)="deletePack(item)">delete</mat-icon>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
